export const REACT_NATIVE_TECH = {
  name: "React Native",
  link: "https://reactnative.dev/",
};

export const EXPO_TECH = {
  name: "Expo",
  link: "https://expo.dev/",
};
